import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

type Props = {
	message: string;
	action: {
		name: string;
		href: string;
	};
	ariaLabelText: string;
};

export function InfoButtonToolTip(props: Props) {
	const {
		message,
		action: { name, href },
		ariaLabelText,
	} = props;

	return (
		<Wrapper>
			<ContentWrapper>{message}</ContentWrapper>
			<Button appearance="link" target="_blank" href={href} aria-label={ariaLabelText}>
				{name}
			</Button>
		</Wrapper>
	);
}

export default InfoButtonToolTip;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.div({
	padding: `0 ${token('space.100', '8px')}`,
	margin: `0 ${token('space.050', '4px')}`,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	maxWidth: '280px',
	padding: token('space.200', '16px'),
});
